import React from 'react';
import { createRoot } from 'react-dom/client';

import ConsentBanner from './components/ConsentBanner/ConsentBanner';

// Mounts the consent banner when the server rendered its root (only while
// consent gating is enabled). A no-op otherwise, so it ships dormant.
export default function renderConsentBanner() {
  const root = document.getElementById('consent-banner-root');
  if (!root) { return; }

  const configElement = document.getElementById('consent-banner-config');
  if (!configElement) { return; }

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  createRoot(root).render(<ConsentBanner config={config} />);
}
